import {
  wrapperStyles,
  tilesWrapperStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  typoLargeNumber,
  typoHeader,
  typoSmall,
  sectionWrapperTabletStyles,
  typoHeaderMobile,
  wrapperWithMarginTabletStyles
} from 'components/Templates/styles/Red/commonObjectsStyles';


/* eslint-disable */
const thisStyle = {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  sectionTitle: {
    '0': {
      ...typoHeader
    },
    '76_8' : {
      ...typoHeaderMobile,
      'margin-bottom' : '0.5rem'
    },
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  insightsWrapper: {
    '0': {
      ...tilesWrapperStyles,
      'margin-top' : '6rem',
      'flex-wrap' : 'wrap',
      'justify-content' : 'space-around',
    }
  },
  insight: {
    '0': {
      'display': 'flex',
      'flex-direction': 'column',
      'align-items': 'center',
    },
    '37_5' : {
      'width': '100%',
      'margin-bottom' : '2rem'
    }
  },
  insightSubtitleOne: {
    '0': {
      ...typoSmall,
      'position': 'relative',
      'display': 'block',
      'margin-top' : '3rem',
    }
  },
  insightSubtitleTwo: {
    '0': {
      ...typoSmall,
      'position': 'relative',
      'display': 'block',
      'margin-top' : '3rem',
    }
  },
  insightSubtitleThree: {
    '0': {
      ...typoSmall,
      'position': 'relative',
      'display': 'block',
      'margin-top' : '3rem',
    }
  },
  insightSubtitleFour: {
    '0': {
      ...typoSmall,
      'position': 'relative',
      'display': 'block',
      'margin-top' : '3rem',
    }
  },
  insightNumberOne: {
    '0': {
      ...typoLargeNumber,
      'color' : '{textColor}'
    }
  },
  insightNumberTwo: {
    '0': {
      ...typoLargeNumber,
      'color' : '{textColor}'
    }
  },
  insightNumberThree: {
    '0': {
      ...typoLargeNumber,
      'color' : '{graphVividColor}'
    }
  },
  insightNumberFour: {
    '0': {
      ...typoLargeNumber,
      'color' : '{primaryColor}'
    }
  },
};


export default thisStyle;
